import { useAnalyticsV2QueryMeasure } from '_hooks/gqty/analytics-v2.hooks'

import {
  FILTER_OPERATOR_EQUALS,
  SITE_ATTRIBUTES_LOCATION_COUNT_MEASURE,
  SITE_ATTRIBUTES_SITE_ID_DIMENSION,
  SITE_ATTRIBUTES_TIMEZONE_DIMENSION,
} from './timezone-indicator.constants'

export const useSiteTimezone = (siteId) => {
  const skip = !siteId
  const result = useAnalyticsV2QueryMeasure(
    {
      measures: [SITE_ATTRIBUTES_LOCATION_COUNT_MEASURE],
      dimensions: [SITE_ATTRIBUTES_TIMEZONE_DIMENSION],
      filters: skip
        ? []
        : [
            {
              member: SITE_ATTRIBUTES_SITE_ID_DIMENSION,
              operator: FILTER_OPERATOR_EQUALS,
              values: [siteId],
            },
          ],
    },
    skip,
    { refetchWhileColdCache: true }
  )
  const row = result.data?.rows?.[0]
  if (!row) {
    return null
  }
  const raw = row[SITE_ATTRIBUTES_TIMEZONE_DIMENSION]
  if (typeof raw !== 'string' || raw === '') {
    return null
  }
  return raw
}
